import styled, { css, keyframes } from 'styled-components';

const fadeIn = keyframes`
  from {
    opacity: 0;
  } to {
    opacity: 1;
  }
`;

const hideMenu = (props) => (
  props.hideMenu && css`display: none;`
);

const controlEmphasis = (props) => {
  if (props.isFocused) {
    return css`
      background-color: transparent;
      border-color: ${props => props.invalid ? '#db011c' : '#fe5d71'} !important;
      outline: 0 !important;
      box-shadow: 0 0 0 0.2rem rgba(219, 1, 28, 0.25);
    `;
  } else if (props.invalid) {
    return css`
      border-color: #db011c !important;
    `;
  }
};

const StyledDropdownWrapper = styled.div`
  position: relative;
  width: 100%;
  box-sizing: border-box;
  display: block;
`;

const StyledFormFeedback = styled.div`
  width: 100%;
  margin-top: 0.25rem;
  font-size: 85%;
  color: #db011c;
  display: block;
  animation: ${fadeIn} .35s both ease-in-out;
`;

const StyledControlWrapper = styled.div`
  opacity: ${props => props.disabled ? '0.3' : '1'};
  cursor: ${props => props.disabled ? 'none' : 'default'};
  border-radius: 0px;
  align-items: center;
  position: relative;
  display: flex;
  flex-wrap: wrap;
  outline: 0px !important;
  background-color: #fff;
  justify-content: space-between;
  cursor: default;
  border-color: #ced4da;
  color: #495057;
  border-style: solid;
  border-width: 1px;
  height: calc(1.5em + 0.75rem + 2px);
  background-clip: padding-box;
  box-sizing: border-box;
  transition: all .15s;

  :hover {
    border-color: hsl(0, 0%, 70%);
  }

  ${(props) => controlEmphasis(props)}
`;

const StyledValueWrapper = styled.div`
  align-items: center;
  position: relative;
  overflow: hidden;
  flex: 1 1 0%;
  padding: 0.375rem 0.75rem;
  display: flex;
  height: 100%;
  box-sizing: border-box;
  flex-wrap: wrap;
`;

const StyledMenuWrapper = styled.div`
  position: absolute;
  width: 100%;
  z-index: 999;
  background-color: #fff;
  margin-top: 8px;
  margin-bottom: 8px;
  border-radius: 0px;
  box-shadow: 0 0 0 1px hsla(0, 0%, 0%, 0.1), 0 4px 11px hsla(0, 0%, 0%, 0.1);
  
  ${props => hideMenu(props)}
`;

export {
  StyledFormFeedback,
  StyledDropdownWrapper,
  StyledControlWrapper,
  StyledValueWrapper,
  StyledMenuWrapper,
};